import { FormControl, FormLabel, HStack, Input } from '@chakra-ui/react'
import { FC } from 'react'

import AlcadaCheckbox from './AlcadaCheckbox'

interface LotesSemRecomendacaoFieldsProps {
  itensSemRecomendacao: boolean
  lotesDe: string
  lotesAte: string
  onToggle: (value: boolean) => void
  onLotesDeChange: (value: string) => void
  onLotesAteChange: (value: string) => void
}

// Aceita apenas inteiros (lotes múltiplos)
const onlyIntegers = (value: string) => value.replace(/\D/g, '')

export const validateLotesSemRecomendacao = (
  itensSemRecomendacao: boolean,
  lotesDe: string,
  lotesAte: string
): string[] => {
  if (!itensSemRecomendacao) return []

  if (!lotesDe || !lotesAte) {
    return [
      'Informe os campos De e Até (lotes) para itens sem recomendação de compra.'
    ]
  }

  const errors: string[] = []
  if (Number(lotesDe) < 1) {
    errors.push('Campo De (lotes) deve ser maior ou igual a 1.')
  }
  if (Number(lotesDe) > Number(lotesAte)) {
    errors.push('Campo De (lotes) não pode ser maior que Campo Até (lotes).')
  }
  return errors
}

// Faixa De/Até (%) da alçada: obrigatória, não negativa e com Até >= De
export const validateFaixaPercentual = (de: string, ate: string): string[] => {
  const errors: string[] = []
  const deVazio = de === '' || de == null
  const ateVazio = ate === '' || ate == null
  if (deVazio) errors.push('Campo De (%) é obrigatório.')
  if (ateVazio) errors.push('Campo Até (%) é obrigatório.')
  if (!deVazio && (Number.isNaN(Number(de)) || Number(de) < 0)) {
    errors.push('Campo De (%) deve ser um número maior ou igual a 0.')
  }
  if (!ateVazio && (Number.isNaN(Number(ate)) || Number(ate) < 0)) {
    errors.push('Campo Até (%) deve ser um número maior ou igual a 0.')
  }
  if (!deVazio && !ateVazio && Number(ate) < Number(de)) {
    errors.push('Campo Até (%) deve ser maior ou igual ao Campo De (%).')
  }
  return errors
}

// Sempre envia os 3 campos: se omitidos no PUT, o backend desliga a flag
export const buildLotesSemRecomendacaoPayload = (
  itensSemRecomendacao: boolean,
  lotesDe: string,
  lotesAte: string
) => ({
  itensSemRecomendacao,
  lotesDe: itensSemRecomendacao ? Number(lotesDe) : null,
  lotesAte: itensSemRecomendacao ? Number(lotesAte) : null
})

const LotesSemRecomendacaoFields: FC<LotesSemRecomendacaoFieldsProps> = ({
  itensSemRecomendacao,
  lotesDe,
  lotesAte,
  onToggle,
  onLotesDeChange,
  onLotesAteChange
}) => (
  <>
    <AlcadaCheckbox isChecked={itensSemRecomendacao} onChange={onToggle}>
      Itens sem recomendação de compra
    </AlcadaCheckbox>

    {itensSemRecomendacao && (
      <HStack spacing={4} mb={4} align="start">
        <FormControl isRequired>
          <FormLabel>De (lotes)</FormLabel>
          <Input
            type="number"
            min={1}
            step={1}
            borderColor="gray.400"
            _hover={{ borderColor: 'gray.600' }}
            value={lotesDe}
            onChange={e => onLotesDeChange(onlyIntegers(e.target.value))}
          />
        </FormControl>

        <FormControl isRequired>
          <FormLabel>Até (lotes)</FormLabel>
          <Input
            type="number"
            min={1}
            step={1}
            borderColor="gray.400"
            _hover={{ borderColor: 'gray.600' }}
            value={lotesAte}
            onChange={e => onLotesAteChange(onlyIntegers(e.target.value))}
          />
        </FormControl>
      </HStack>
    )}
  </>
)

export default LotesSemRecomendacaoFields
